import React from 'react';
import { Calculator } from 'lucide-react';
import { VARIABLE_BY_ID } from '../../data/formulas';

interface FormulaEmptyStateProps {
  selectedKnownsCount: number;
  selectedTarget: string;
}

export const FormulaEmptyState: React.FC<FormulaEmptyStateProps> = ({
  selectedKnownsCount,
  selectedTarget,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center space-y-3">
      <div className="rounded-full bg-paper-200 p-4 dark:bg-study-card">
        <Calculator className="h-8 w-8 text-zinc-400" />
      </div>
      <h3 className="font-serif text-sm font-bold text-zinc-800 dark:text-zinc-200">
        {!selectedTarget && selectedKnownsCount > 0
          ? 'Agora selecione a Incógnita Alvo'
          : selectedTarget && selectedKnownsCount === 0
          ? 'Agora adicione os Dados Conhecidos'
          : 'Como funciona o Localizador Tático'}
      </h3>
      <div className="max-w-md text-xs leading-relaxed text-zinc-500 dark:text-zinc-400">
        {!selectedTarget && selectedKnownsCount > 0 ? (
          <p>
            Você já selecionou <strong>{selectedKnownsCount} dado(s)</strong> no painel esquerdo.
            <br />
            Clique em <strong className="text-amber-600 dark:text-amber-400">🎯 Alvo</strong> na grandeza que o exercício pede para deduzir a fórmula.
          </p>
        ) : selectedTarget && selectedKnownsCount === 0 ? (
          <p>
            Alvo definido: <strong>{VARIABLE_BY_ID[selectedTarget]?.name}</strong>.
            <br />
            Clique em <strong className="text-indigo-600 dark:text-indigo-400">+ Dado</strong> nas grandezas fornecidas pelo enunciado para traçar a dedução.
          </p>
        ) : (
          <p>
            1. Adicione os dados numéricos que o enunciado forneceu (ex.: velocidade inicial, aceleração).
            <br />
            2. Clique em <strong>🎯 Alvo</strong> na grandeza que o exercício pede.
            <br />
            3. O motor calcula a fórmula-ponte ideal e as questões reais correspondentes instantaneamente.
          </p>
        )}
      </div>
    </div>
  );
};
